import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DirectiveSuperclass } from '@sama/ng-core';
import { TaskPausingService } from '../task-pausing/task-pausing.service';

@Component({
  selector: 'h3-pause-task-button',
  templateUrl: './pause-task-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PauseTaskButtonComponent extends DirectiveSuperclass {
  private taskPausingService = inject(TaskPausingService);

  pauseTask() {
    this.taskPausingService.pause({ method: 'pause_button' });
  }
}
